






import { Vue, Component, Prop } from 'vue-property-decorator'
import { IMessage } from '../../../../api_interface'

@Component
export default class extends Vue {
  @Prop({ required: true })
  message!: IMessage

  get title() {
    return localizedContent(this.$i18n.locale, this.message, 'title')
  }

  get html() {
    return localizedContent(this.$i18n.locale, this.message, 'html')
  }
}

function localizedContent(locale: string, o: any, key: string) {
  const locales = [locale, 'en', 'ja']
  for (const l of locales) {
    const c = o[`${l}_${key}`]
    if (c)
      return c
  }
  return ''
}
